import * as React from 'react';
import {
  Empty,
  Typography,
} from '@revfluence/fresh';
import { Empty as ShadcnEmpty } from '@frontend/app/refresh-components';
import { PhotoFilmIcon } from '@revfluence/fresh-icons/regular/esm';
import { TemplateType } from '@frontend/applications/TermsApp/components/ContentGuidelines/types/state';
import { DropdownMenu, DropdownMenuItem, DropdownMenuContent, DropdownMenuTrigger } from '@frontend/shadcn/components/ui/dropdown-menu';
import { Button as ShadcnButton } from '@frontend/shadcn/components/ui/button';
import { PlusIcon } from '@revfluence/fresh-icons/regular/esm';

interface GuidelinesListEmptyProps {
  showFlexUI?: boolean;
  onSelectTemplateType?: (templateType: TemplateType) => void;
}
const GuidelinesListEmpty = React.memo(({ showFlexUI = false, onSelectTemplateType }: GuidelinesListEmptyProps) => {
  if (showFlexUI) {
    return (
      <ShadcnEmpty
        icon={PhotoFilmIcon}
        title="No content guidelines found"
        description="Create a content guideline to send with briefs."
        layout="horizontal"
        size="lg"
        withBackground
        primaryCta={
          <DropdownMenu>
            <DropdownMenuTrigger asChild className="self-start mt-0.5">
              <ShadcnButton variant="primary">
                <PlusIcon className="mr-1.5" />
                Add Content Guideline
              </ShadcnButton>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem
                onSelect={() => onSelectTemplateType?.(TemplateType.PremadeTemplates)}
              >
                Select Premade Template
              </DropdownMenuItem>
              <DropdownMenuItem
                onSelect={() => onSelectTemplateType?.(TemplateType.OtherProjectTemplates)}
              >
                Select from another project
              </DropdownMenuItem>
              <DropdownMenuItem
                onSelect={() => onSelectTemplateType?.(TemplateType.BlankTemplates)}
              >
                Start from Blank Template
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        }
      />
    );
  }

  return (
    <Empty
      style={{
      alignSelf: 'center',
    }}
      image={(
        <PhotoFilmIcon
          color="#F0F0F0"
          width={80}
          height={80}
        />
    )}
      imageStyle={{
      height: '48px',
      marginBottom: '52px',
    }}
      description={(
        <>
          <Typography.Title level={5}>
            No content guidelines for this project
          </Typography.Title>
          <Typography.Paragraph
            type="secondary"
            style={{
            fontSize: '14px',
          }}
          >
            Select from one of our suggested templates, use templates from another project, or start from scratch.
          </Typography.Paragraph>
        </>
    )}
    />

);
});

GuidelinesListEmpty.displayName = 'GuidelinesListEmpty';

export default GuidelinesListEmpty;
